import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IApprovalsYearMonthFiltersState } from "./interfaces";
import { getYearMonthForUseTaxCalculationFilter } from "utils";

const yearMonth = getYearMonthForUseTaxCalculationFilter();
const initialState: IApprovalsYearMonthFiltersState = {
  year: yearMonth[0],
  month: yearMonth[1],
};

export const approvalYearMonthFiltersSlice = createSlice({
  name: "approvalsYearMonthFilters",
  initialState,
  reducers: {
    updateYear: (state, action: PayloadAction<number>) => {
      state.year = action.payload;
    },
    updateMonth: (state, action: PayloadAction<string>) => {
      state.month = action.payload;
    },
  },
});

export const { updateYear, updateMonth } =
  approvalYearMonthFiltersSlice.actions;

export default approvalYearMonthFiltersSlice.reducer;
